import SwiperGif from "../../../../../assets/gif/discover-swipe.gif";
import "./index.less";

const SwiperGifComponent = () => {
  return <img src={SwiperGif} className="swiper-gif" alt="Swiper GIF" />;
};

export default SwiperGifComponent;
